import { render, staticRenderFns } from "./PreordersTable.vue?vue&type=template&id=03f0e360&"
import script from "./PreordersTable.vue?vue&type=script&lang=js&"
export * from "./PreordersTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports